// in SubGenreInput.js
import React, { Component } from 'react';
import {SelectInput } from 'admin-on-rest';
import { Field } from 'redux-form';
import { queryParameters } from '../../utils';

class SubGenreInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
        title: '?',
        subgenres: []
        };
    }
    //
    //  // This is necessary so that the SelectInput receive all its required props
    //  // from redux-form
    //  static defaultProps = { addField: true };
    //

    handleChange() {
        this.setState({value: ''});
    }

    componentDidMount() {
        console.log("here",this.props);
        console.log("componentDidMount",this.state);

        this.fetchData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        console.log("nextProps",nextProps);
        if (nextProps.dependsOnValue !== this.props.dependsOnValue) {
            this.fetchData(nextProps);
        }
    }

    fetchData(props) {
        console.log("props",props.dependsOnValue);
        var _id=props.dependsOnValue;
        localStorage.setItem('companyID', _id);
        var auth_token = localStorage.getItem('auth_token');
        var token = localStorage.getItem('token');
        var token_query = {token:auth_token,id:token};

        fetch(`https://api.theboxapp.gr/api/all_branches/`+_id+`?${queryParameters(token_query)}`, { method: 'GET' })
              .then(response => response.json())
              .then(response => {
                    console.log("data",response.data);
                    var data= response.data;
                    var subgenres=data;
                    // for(i=0;i<data.length;i++){
                    //     subgenres.push
                    // }
                    this.setState({ subgenres });
                    })
              .catch((e) => {
                     console.error(e);
                     });
              }

              render() {
              const createItem = (item, key) =>
              <option
              key={key}
              value={item._id}
              >
              {item.tmima_address}
              </option>;
              return (
                      <div>
                      <Field
                      name="BranchID"
                      component="select"
                      style={{
                      boxSizing: `border-box`,
                      border: `1px solid transparent`,
                      width: `240px`,
                      height: `32px`,
                      marginTop: `27px`,
                      padding: `0 12px`,
                      borderRadius: `3px`,
                      boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                      fontSize: `14px`,
                      outline: `none`,
                      textOverflow: `ellipses`,
                      }}>
                      <option></option>
                      {this.state.subgenres.map(createItem)}
                      </Field>
                      </div>
                      );
              }
              }


              SubGenreInput.propTypes = SelectInput.propTypes;
              SubGenreInput.defaultProps = SelectInput.defaultProps;

              export default SubGenreInput;



// WEBPACK FOOTER //
// ./src/pages/custom/SubGenreInput.js